<template>
  <aqt-table refresh @on-refresh="refreshData" :pageDate="pageDate" @on-pageChange="refreshData">
    <div slot="table" style="margin-bottom: 10px; display: flex">
      <Button v-if="userType==4" type="primary" style="margin-right:5px" @click="addData">投稿</Button>
      <Input v-model="condition.title" placeholder="标题检索" search @on-search="refreshData(1)" style="width: 200px; margin-right: 10px"/>
      <Input v-if="userType!=4" v-model="condition.author" placeholder="作者检索" search @on-search="refreshData(1)" style="width: 200px; margin-right: 10px"/>
      <Input v-model="condition.keywords" placeholder="关键词检索" search @on-search="refreshData(1)" style="width: 200px; margin-right: 10px"/>
      <DatePicker @on-change="timeChange" style="width: 220px;margin-right: 10px" type="daterange" :show-week-numbers="true" placement="bottom-end"
                  placeholder="时间检索"></DatePicker>
<!--      <Select v-if="!['/doHandledb','/doHandleyb','/doHandlezzb'].includes($route.path)" v-model="condition.status" :placeholder="'状态'" @on-change="refreshData(1)" filterable clearable style="width: 150px; margin-right: 5px">-->
<!--        <Option v-for="(item, index) in statusList" :value="item.lebal" :key="index">{{ item.name }}</Option>-->
<!--      </Select>-->

      <Select v-if="userType==1" v-model="condition.zhuanjia_id" @on-change="refreshData(1)" :placeholder="'评审人'" filterable clearable style="width: 150px; margin-right: 5px">
        <Option v-for="(item, index) in experList" :value="item.users_id" :key="index">{{ item.name }}</Option>
      </Select>
      <Button type="primary" style="margin-right:5px" @click="refreshData(1)">检索</Button>
    </div>
    <Table border stripe :loading="tableLoading" :columns="columns" :data="data" slot="table"></Table>
    <aqt-sidebar v-model="show" :title="titles" slot="others">
      <component :is="content" :infoData="infoData" :userType="userType" @operationState="operationState"></component>
    </aqt-sidebar>

    <Modal slot="table" :width="350" v-model="fenpeiModal" :title="titles">
      <Select v-model="fpform.zhuanjia_id" :placeholder="`${$t('m.please_select')+$t('m.reviewer')}`" filterable clearable>
        <Option v-for="(item, index) in teacherList" :value="item.users_id" :key="index">{{ item.name }}</Option>
      </Select>
      <div slot="footer">
        <Button type="primary" @click="fenpeiOk" :loading="fpLoading" :disabled="fpform.zhuanjia_id?false:true">确定</Button>
      </div>
    </Modal>

  </aqt-table>
</template>

<script>
export default {
  components: {
    Operation: resolve => {require(['./Operation.vue'], resolve);},
    CheckData: resolve => {require(['./CheckData.vue'], resolve);},//查看
    printCheck: resolve => {require(['./printCheck.vue'], resolve);},
  },
  data() {
    return {
      userType:localStorage.getItem('user_type'),//4作者 3专家 2编辑 1管理员
      tableLoading: false,
      show: false,
      titles: '',
      content: '',
      infoData:false,
      fenpeiModal:false,
      pageDate: {
        total: 1,
        current_page: 1,
        per_page: 1,
      },
      condition:{
        library_id:localStorage.getItem('libId'),
        title:'',
        status:null,
        zhuanjia_id:null,
        author:'',
        keywords:'',
        time:[],
        page:1,
        gjstatus:'',//不传是全部 1待办 2正办 3已办
      },
      data: [],
      columns:[],
      columns1: [
        {
          title: '标题(蒙古文)',
          minWidth: 100,
          align: 'center',
          render: (h,params) => {
            return h('div', {
              class: {
                'contentfont': true,
              }
            },params.row.titlelang&&params.row.titlelang.mn?params.row.titlelang.mn.slice(0, 100):'')
          }
        },
        {
          title: '标题(中文)',
          minWidth: 100,
          align: 'center',
          render: (h,params) => {
            return h('div',params.row.titlelang&&params.row.titlelang.zh?params.row.titlelang.zh.slice(0, 50):'')
          }
        },
        {
          title: '标题(英文)',
          minWidth: 100,
          align: 'center',
          render: (h,params) => {
            return h('div', params.row.titlelang&&params.row.titlelang.en?params.row.titlelang.en.slice(0, 100):'')
          }
        },
        {
          title: '作者',
          width: 200,
          align: 'center',
          render: (h,params) => {
            return h('div', {
              class: {
                'contentfont': params.row.authorlang&&params.row.authorlang.mn?true:false,
              }
            },params.row.authorlang?(params.row.authorlang.zh||params.row.authorlang.mn):'')
          }
        },
        {
          title: '稿件类型',
          width: 200,
          align: 'center',
          render: (h,params) => {
            return h('div',params.row.class_name?params.row.class_name:'')
          }
        },
        {
          title: '编号',
          width: 200,
          align: 'center',
          key: 'number',
        },
        {
          title: '投稿时间',
          width: 200,
          align: 'center',
          key: 'created_at',
        },
        {
          title: '当前阶段',
          width: 200,
          align: 'center',
          render: (h,params) => {
            return h('div',this.getstatusName(params.row.stage)+'（'+this.getstatusName(params.row.status)+'）')
          }
        },
        {
          title: '评审人',
          width: 200,
          align: 'center',
          render: (h,params) => {
            return h('div',params.row.zhuanjia_name?params.row.zhuanjia_name:'')
          }
        },
      ],
      columns23: [
        {
          title: '标题(蒙古文)',
          minWidth: 100,
          align: 'center',
          render: (h,params) => {
            return h('div', {
              class: {
                'contentfont': true,
              }
            },params.row.titlelang&&params.row.titlelang.mn?params.row.titlelang.mn.slice(0, 100):'')
          }
        },
        {
          title: '标题(中文)',
          minWidth: 100,
          align: 'center',
          render: (h,params) => {
            return h('div',params.row.titlelang&&params.row.titlelang.zh?params.row.titlelang.zh.slice(0, 50):'')
          }
        },
        {
          title: '标题(英文)',
          minWidth: 100,
          align: 'center',
          render: (h,params) => {
            return h('div', params.row.titlelang&&params.row.titlelang.en?params.row.titlelang.en.slice(0, 100):'')
          }
        },
        {
          title: '作者',
          width: 200,
          align: 'center',
          render: (h,params) => {
            return h('div',{
              class: {
                'contentfont': params.row.authorlang&&params.row.authorlang.mn?true:false,
              }
            },params.row.authorlang?(params.row.authorlang.zh||params.row.authorlang.mn):'')
          }
        },
        {
          title: '稿件类型',
          width: 200,
          align: 'center',
          render: (h,params) => {
            return h('div',params.row.class_name?params.row.class_name:'')
          }
        },
        {
          title: '编号',
          width: 200,
          align: 'center',
          key: 'number',
        },
        {
          title: '投稿时间',
          width: 200,
          align: 'center',
          key: 'created_at',
        },
        {
          title: '当前阶段',
          width: 200,
          align: 'center',
          render: (h,params) => {
            return h('div',this.getstatusName(params.row.stage)+'（'+this.getstatusName(params.row.status)+'）')
          }
        },
      ],
      columns4: [
        {
          title: '标题(蒙古文)',
          minWidth: 100,
          align: 'center',
          render: (h,params) => {
            return h('div', {
              class: {
                'contentfont': true,
              }
            },params.row.titlelang&&params.row.titlelang.mn?params.row.titlelang.mn.slice(0, 100):'')
          }
        },
        {
          title: '标题(中文)',
          minWidth: 100,
          align: 'center',
          render: (h,params) => {
            return h('div',params.row.titlelang&&params.row.titlelang.zh?params.row.titlelang.zh.slice(0, 50):'')
          }
        },
        {
          title: '标题(英文)',
          minWidth: 100,
          align: 'center',
          render: (h,params) => {
            return h('div', params.row.titlelang&&params.row.titlelang.en?params.row.titlelang.en.slice(0, 100):'')
          }
        },
        {
          title: '稿件类型',
          width: 200,
          align: 'center',
          render: (h,params) => {
            return h('div',params.row.class_name?params.row.class_name:'')
          }
        },
        {
          title: '编号',
          width: 200,
          align: 'center',
          key: 'number',
        },
        {
          title: '投稿时间',
          width: 200,
          align: 'center',
          key: 'created_at',
        },
        {
          title: '当前阶段',
          width: 200,
          align: 'center',
          render: (h,params) => {
            return h('div',this.getstatusName(params.row.stage)+'（'+this.getstatusName(params.row.status)+'）')
          }
        },

      ],
      columnsfooter:[ {
        title: '操作',
        key: 'action',
        width: 200,
        align: 'center',
        render: (h, params) => {
          return h('div', [
            h('Button', {
              props: {
                type: 'info',
                size: 'small'
              },
              style: {
                margin: '2px',
              },
              on: {
                click: () => {
                  this.infoData = params.row.manuscript_id;
                  this.content = 'CheckData';
                  this.titles = '查看';
                  this.show = true;
                }
              }
            }, '查看'),
            h('Button', {
              props: {
                type: 'warning',
                size: 'small',
              },
              style: {
                margin: '2px',
                display:this.userType==2&&this.userData.user_type_status==1&&params.row.zhuanjia_id==0?'inline-table':'none'
              },
              on: {
                click: () => {
                  this.fpform.id = JSON.stringify([params.row.manuscript_id]);
                  this.fenpeiModal = true
                  this.fpform.zhuanjia_id = ''
                  this.titles = this.$t('m.fpexpert')
                }
              }
            }, '分配'),
            h('Button', {
              props: {
                type: 'primary',
                size: 'small',
                disabled: ((params.row.status==0&&params.row.zhuanjia_id==0)||params.row.status==2)?false:true//初审作者修改中
              },
              style: {
                margin: '2px',
                display:this.userType==4?'inline-table':'none'
              },
              on: {
                click: () => {
                  this.infoData = params.row.manuscript_id
                  this.content = 'Operation'
                  this.titles = '修改'
                  this.show = true
                }
              }
            }, '修改'),
            h('Poptip', {
              props: {
                confirm: true,
                transfer: true,
                title: '您确定要删除这条数据吗?',
                type: 'error',
                size: 'small',
                placement:'left-end',
                disabled:this.del.length?true:false
              },
              style: {
                textAlign: 'left',
              },
              on: {
                'on-ok': () => {
                  this.del = [params.row.manuscript_id];
                  this.delSubmit ();
                }
              }
            }, [
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                  disabled: (params.row.status==0&&params.row.zhuanjia_id==0)?false:true,//已退稿件
                  loading:this.del.length==1&&this.del[0]==params.row.manuscript_id?true:false
                },
                style: {
                  margin: '2px',
                  display:this.userType==4?'inline-table':'none',
                },
              }, '删除')
            ]),
            h('Button', {
              props: {
                type: 'warning',
                size: 'small',
              },
              style: {
                margin: '2px',
                display:this.userData.users_id==params.row.chushen_id&&(params.row.status==4||params.row.status==5)?'inline-table':'none',//当前用户id = 初审人id
              },
              on: {
                click: () => {
                  this.infoData = params.row.manuscript_id;
                  this.content = 'printCheck';
                  this.titles = '打印';
                  this.show = true;
                }
              }
            }, '打印'),
          ]);
        }
      }],


      del: [],

      statusList:[
        {
          name:'未审核',
          lebal:0
        },
        {
          name:'初审',
          lebal:1
        },
        {
          name:'作者修改中',
          lebal:2
        },
        {
          name:'作者修回稿件',
          lebal:3
        },
        {
          name:'已录用稿件',
          lebal:4
        },
        {
          name:'已退稿件 ',
          lebal:5
        },
        {
          name:'复审',
          lebal:6
        },
        {
          name:'外审',
          lebal:7
        },
        {
          name:'终审',
          lebal:8
        },
        {
          name:'审核中',
          lebal:9
        }
      ],

      experList:[],
      teacherList:[],
      fpform:{
        zhuanjia_id:'',
        id:'',
        library_id:localStorage.getItem('libId'),
        users_type:localStorage.getItem('user_type'),
      },
      fpLoading:false,
      userData:''

    }
  },
  methods: {
    timeChange(time) {
      if (time.includes('')) {
        this.condition.time = [];
      } else {
        this.condition.time = time;
      }
      this.refreshData(1)
    },
    getstatusName (value) {
      let gg = this.statusList.find(i => {
        return i.lebal == value
      });
      return gg?gg.name:'';
    },
    /*****************************************************************
     *
     * 添加数据返回状态
     * @param   {data}             状态
     *
     *****************************************************************/
    operationState (data) {
      if (data) this.show = false
      this.refreshData (this.pageDate.current_page)
    },

    /************************************************************
     *
     * 添加数据
     *
     ************************************************************/
    addData () {
      this.infoData = false
      this.content = 'Operation'
      this.titles = '上传资料'
      this.show = true
    },

    /************************************************************
     *
     * 删除确认
     *
     ************************************************************/
    delData () {
      if(!this.del.length){
        this.$Message.warning('请选择要删除的内容')
        return
      }
      this.$Modal.confirm({
        title: '删除确认',
        closable: true,
        loading: true,
        content: '您确定要删除这些数据吗?',
        onOk: () => {
          this.delSubmit ()
        }
      })
    },

    /************************************************************
     *
     * 删除操作
     *
     ************************************************************/
    delSubmit () {
      let cond = {
        id:JSON.stringify(this.del)
      }
      this.$httpsencrypt.post('api/contributeweb/v3/manuscript/dels' ,cond).then(val=>{
        this.$Modal.remove ()
        this.refreshData (this.pageDate.current_page)
        this.$Message.success('删除成功!');
        this.del=[]
      }).catch(err => {
        this.del=[]
        this.$Modal.remove ()
        this.$Message.error('删除失败!');
      })
    },

    /************************************************************
     *
     * 列表数据
     *
     ************************************************************/
    queryData (index) {
      const _this = this
      _this.condition.page = index
      if(_this.$route.path=='/doHandledb'){
        _this.condition.gjstatus = 1
      }else if(_this.$route.path=='/doHandlezzb'){
        _this.condition.gjstatus = 2
      }else if(_this.$route.path=='/doHandleyb'){
        _this.condition.gjstatus = 3
      }else {
        _this.condition.gjstatus = ''
      }
      _this.$httpsencrypt.post(`api/contributeweb/v3/manuscript/list`,_this.condition)
          .then(val =>{
            _this.data = val.data;
            _this.tableLoading = false;
            _this.pageDate.current_page = val.pages.current_page;
            _this.pageDate.per_page = val.pages.per_page;
            _this.pageDate.total = val.pages.total;
          }).catch(err =>{
        _this.tableLoading=false;
      })
    },

    /************************************************************
     *
     * 刷新
     *
     ************************************************************/
    refreshData (index) {
      this.data = []
      this.tableLoading = true
      this.queryData (index ? index : 1)
    },

    fenpeiOk(){
      this.fpLoading = true
      this.$httpsencrypt.post('api/contributeweb/v3/manuscript/fpzj' ,this.fpform).then(val=>{
        this.fenpeiModal = false
        this.fpLoading = false
        this.refreshData (this.pageDate.current_page)
        this.$Message.success('分配成功!');
      }).catch(err => {
        this.fenpeiModal = false
        this.fpLoading = false
        this.$Message.error('分配失败!');
      })
    },

    /************************************************************
     *
     * 获取专家列表
     *
     ************************************************************/
    getExperList(){
      const _this = this
      let cond = {
        library_id:localStorage.getItem('libId'),
        user_type:23
      }
      _this.$httpsencrypt.post(`api/contributeweb/v3/users/index`,cond)
          .then(val =>{
            if(val.code==200&&val.data.length){
              _this.experList = val.data
            }else {
              _this.experList = []
            }
          }).catch(err =>{
        _this.experList = []
      })

      let cond1 = {
        library_id:localStorage.getItem('libId'),
        user_type:2
      }
      _this.$httpsencrypt.post(`api/contributeweb/v3/users/index`,cond1)
          .then(val =>{
            if(val.code==200&&val.data.length){
              _this.teacherList = val.data
            }else {
              _this.teacherList = []
            }
          }).catch(err =>{
        _this.teacherList = []
      })
    },
  },
  created() {
    this.userData = JSON.parse(this.userInfo)

    if(this.userType==3||this.userType==2){
      this.columns=this.columns23.concat(this.columnsfooter)
    }else if(this.userType==1){
      this.columns=this.columns1.concat(this.columnsfooter)
    }else if(this.userType==4){
      this.columns=this.columns4.concat(this.columnsfooter)
    }
    if(this.userType==1||(this.userType==2&&this.userData.user_type_status==1)){
      this.getExperList()
    }
    this.refreshData ()
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
  },
  watch: {
    userInfo: {
      handler(val, oldValue) {
        this.userData = val?JSON.parse(val):''
      },
      deep: true
    }
  },
};
</script>

<style lang="less" scoped>
</style>
